import React from 'react';

import { Text, Title, Spacing } from '@vkontakte/vkui';

import styles from './index.module.css';
import { ResultProps } from './types';

export const Result: React.FC<ResultProps> = ({ title, temperamentData }) => {
  return (
    <div>
      <div style={{ margin: '0 32px' }}>
        <Text className={styles.title}>
                    Результаты готовы!
        </Text>
        <Title level="2" weight="2" style={{ textAlign: 'center' }}>
          {title}
        </Title>
      </div>

      <Spacing size={24} />

      <div className={styles.img}>
        {temperamentData.image.mobile}
      </div>
    </div>
  );
};
